import React from "react";

const RepublicIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_852)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.75 0.07C28.5049 0.481418 33.1752 4.88639 33.9221 10.6074C34.6691 16.3284 31.2863 21.7848 25.83 23.66L38 40H2V0H20.94C21.59 0 22.2 0 22.75 0.07Z",
  fill: "#157EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.45 40H2V0L37.76 40H25.45Z",
  fill: "#157EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.01 40H2L19.88 12.07L38.01 40Z",
  fill: "#00BDFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 23.15V0H12.05L27.07 23.14L2 23.15Z",
  fill: "#1560FA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.79 23.15L19.88 12.07L27.07 23.15H12.79Z",
  fill: "#00EFE9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.01 40H24.63L19.88 12.07L38.01 40Z",
  fill: "#157EFF",
  fillOpacity: 0.5
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_852"
}, /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 40,
  fill: "white",
  transform: "translate(2)"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(RepublicIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;